import { useCallback, useState } from "react";
import { useCreateUser } from "../../../fnx/user/userCreate";
import { useUserPatch } from "../../../fnx/user/userPatch";
export var useCreateOrEditUser = function (userId) {
    var _a = useState(false), isEdit = _a[0], setIsEdit = _a[1];
    var _b = useState(false), triggerCreate = _b[0], setTriggerCreate = _b[1];
    var _c = useState(false), triggerEdit = _c[0], setTriggerEdit = _c[1];
    var _d = useState({}), userFormData = _d[0], setUserFormData = _d[1];
    var _e = useCreateUser(triggerCreate, userFormData), responseUserCreate = _e.responseUserCreate, errorUserCreate = _e.errorUserCreate, loadingUserCreate = _e.loadingUserCreate;
    var _f = useUserPatch(triggerEdit, userFormData, userId), responseUserPatch = _f.responseUserPatch, errorUserPatch = _f.errorUserPatch, loadingUserPatch = _f.loadingUserPatch;
    var handleSubmitUser = useCallback(function (data) {
        var userRequest = {
            name: data.names,
            lastName: data.lastNames,
            email: data.email,
            password: data.password,
            passwordConfirm: data.confirmPassword,
            clientId: data.company,
            branchId: data.branch,
            userName: data.username,
        };
        setUserFormData(userRequest);
        if (isEdit) {
            setTriggerEdit(true);
        }
        else {
            setTriggerCreate(true);
        }
    }, [isEdit]);
    var resetTriggers = useCallback(function () {
        setTriggerCreate(false);
        setTriggerEdit(false);
    }, []);
    var setEditMode = useCallback(function (mode) {
        setIsEdit(mode);
    }, []);
    return {
        isEdit: isEdit,
        setIsEdit: setEditMode,
        handleSubmitUser: handleSubmitUser,
        resetTriggers: resetTriggers,
        loading: loadingUserCreate || loadingUserPatch,
        error: errorUserCreate || errorUserPatch,
        response: isEdit ? responseUserPatch : responseUserCreate,
    };
};
